import classNames from 'classnames';
import View from 'components/View';
import { forwardRef } from 'react';
import styles from './FlexContainer.module.scss';

/**
 * FlexContainer
 *
 * @return {JSX.Element}
 */
const FlexContainer = (
  {
    className,
    column,
    row,
    flex,
    overflow,
    spaceBetween,
    block,
    alignCenter,
    alignStart,
    alignEnd,
    justifyContentEnd,
    justifyContentCenter,
    gap,
    gapHalf,
    gapQuad,
    wrap,
    textEllipsis,
    maxWidth100,
    flip,
    onClick,
    animate,
    ...rest
  },
  ref
) => {
  return (
    <View
      ref={ref}
      onClick={onClick}
      className={classNames(
        styles.FlexContainer,
        column && styles.FlexContainer__column,
        row && styles.FlexContainer__row,
        flex && styles.FlexContainer__flex,
        overflow && styles.FlexContainer__overflow,
        spaceBetween && styles.FlexContainer__spaceBetween,
        block && styles.FlexContainer__block,
        alignCenter && styles.FlexContainer__alignCenter,
        alignStart && styles.FlexContainer__alignStart,
        alignEnd && styles.FlexContainer__alignEnd,
        gap && styles.FlexContainer__gap,
        gapHalf && styles.FlexContainer__gapHalf,
        gapQuad && styles.FlexContainer__gapQuad,
        justifyContentEnd && styles.FlexContainer__justifyContentEnd,
        justifyContentCenter && styles.FlexContainer__justifyContentCenter,
        wrap && styles.FlexContainer__wrap,
        textEllipsis && styles.FlexContainer__textEllipsis,
        maxWidth100 && styles.FlexContainer__maxWidth100,
        flip && styles.FlexContainer__flip,
        onClick && styles.FlexContainer__onClick,
        animate && styles.FlexContainer__animate,
        className,
        `${FlexContainer.displayName}`
      )}
      {...rest}
    />
  );
};

FlexContainer.displayName = 'FlexContainer';

export default forwardRef(FlexContainer);
